import {
  addUserProperties,
  appendUserProperty,
  identifyUser,
  initAmplitude,
  resetAmplitude,
  setGroup,
  setGroupProperties,
  setUserProperties,
  setUserPropertiesOnce,
  trackEvent,
  trackPageView,
  trackRevenue,
} from './client';

const event = trackEvent;
const pageView = trackPageView;
const revenue = trackRevenue;

export {
  addUserProperties,
  appendUserProperty,
  event,
  identifyUser,
  initAmplitude,
  pageView,
  resetAmplitude,
  revenue,
  setGroup,
  setGroupProperties,
  setUserProperties,
  setUserPropertiesOnce,
};

export const Amplitude = {
  init: initAmplitude,
  event,
  pageView,
  revenue,
  identify: identifyUser,
  setUserProperties,
  setUserPropertiesOnce,
  addUserProperties,
  appendUserProperty,
  setGroup,
  setGroupProperties,
  reset: resetAmplitude,
};

export { AmplitudeEvents } from './events';

// Canonical editor UI tracking — see docs/amplitude-editor-ui-events.md.
export { EditorEvents, EditorRegion, EditorTrack } from './editor-events';

// Editor-wide context that auto-injects into every EditorTrack.* event.
export {
  bucketCount,
  clearEditorContext,
  getEditorContext,
  newEditorSessionId,
  patchEditorContext,
  setEditorContext,
} from './editor-context';
export type { EditorContext, ProjectVisibility } from './editor-context';
export type {
  ActionKind,
  CanvasActionProps,
  CanvasGesture,
  CanvasTool,
  ChatActionProps,
  ChatNewSessionProps,
  ChatResponseProps,
  ChatSendProps,
  ContextMenuOpenProps,
  ControlKind,
  CreationProps,
  CreationSource,
  EditorEventName,
  EditorChangeOrigin,
  EditorChangeProvenanceProps,
  EditorChangeSource,
  HistoryProps,
  InteractionKind,
  KeyboardShortcutProps,
  LayoutChangedProps,
  NodeTypeName,
  PanelTrigger,
  PanelViewProps,
  PropertyChangedProps,
  QuickEditProps,
  StyleChangedProps,
  UiClickProps,
  ValueKind,
  ZoomProps,
} from './editor-events';

export type {
  EventProperties,
  InitAmplitudeOptions,
  PageViewProperties,
  RevenueProperties,
  UserProperties,
} from './types';

// Alias `Editor` for shorter call sites: `Editor.history({...})`.
export { EditorTrack as Editor } from './editor-events';

// Core-value retention events — `CoreValueTrack.projectCreated({...})` etc.
// See packages/amplitude/src/core-value.ts for the rationale (de-dup, $setOnce,
// activation, etc.).
export { CoreValueTrack } from './core-value';
export type { CoreValueAction, ProjectCreationMode, ProjectCreationSource } from './core-value';
export { buildProjectCreatedProps, summarizeCreateChatAttachments } from './project-created-props';
export type {
  ProjectCreatedAttachmentInput,
  ProjectCreatedEventProps,
  ProjectCreatedSizeInput,
  ProjectCreatedTrackingInput,
} from './project-created-props';

// AI generation pipeline events — `AiGenerationTrack.start/done/...`.
// See packages/amplitude/src/ai-generation.ts for the funnel design.
export { AiGenerationTrack, newGenerationId, resolveAiGenerationPipeline } from './ai-generation';
export type {
  AiGenerationApi,
  AiGenerationPipeline,
  AiGenerationRequestKind,
  AiGenerationStage,
  AiGenerationStartProps,
  AiGenerationStreamProps,
} from './ai-generation';
